export default {

    //General phrases
    tollWord: 'Fetesti kopru gecis ucreti  | Fetesti kopru gecis ucretleri | Peaje',
    vignetteWord: 'Rovinieta | Rovinieta',

    site_tpf: 'taxa-pod-fetesti.ro',
    site_erv: 'e-rovinieta.ro',

    currency: 'Lei',
    category: 'Kategori',
    select_type_of_vehicle: 'Arac tipini secin ',
    select_the_period: 'Select the period',
    or_pay_for: ' veya    .......     icin odeme yapin ',
    your_vehicles_link: 'Araclariniz',
    or_go_to_your_account_and_buy: 'Veya hesabiniza giris yapin  ve dogrudan arabalariniz icin satin alin ',
    see_cart: 'Sepeti gor ',
    or: ' Veya ',
    and: ' Ve ',
    back: ' Geri  ',
    total: ' Toplam ',
    pf: ' Kisisel',
    pj: 'Tuzel kisi',
    yes: ' Evet ',
    no: 'Hayir ',
    about: 'Hakkinda ',
    us: ' Biz ',

    vignette: 'Rovinieta / rovinietler ',
    passing: 'Gecis / gecisler ',

    toll_buy: ' Kopru gecis ucreti odeyin ',
    vignette_buy: ' Rovinieta \'yi odeyin  ',

    //Order
    billing_add_new_profile: 'Yeni faturalandirma profili ekleyin ',

    cart_empty: ' Sepet bos tur ',
    cart_available_from: ' ... ten itibaren gecerli   valabila din',
    cart_add_more: 'Sepete daha fazlasini eklemeye devam etin  ',
    cart_continue_with_buying: 'Daha fazlasi satin al ',
    cart_validation_errors: 'Dogrulama hatalari nedeniyle siparisten kaldirilan urunler ',

    order_container_place_order_title: 'Siparis verin ',
    order_container_my_cart: 'Sepetim ',
    order_container_billing_info: 'Fatura verileri',
    order_container_payment: 'Odeme ',

    payment_method_insuficient_credit: 'Yetersiz kredi ',
    payment_method_instant_credit: 'Aninda kredi ',
    payment_method_instant_credit_description: 'Aninda kredi ',
    payment_method_credit_card: '  Banka karti ile cevrimici ',
    payment_method_credit_card_description: 'Odeme PayU.ro araciligiyla islenecek ',
    payment_method_iTransfer_description: ' Aninda onayli odeme emri ',
    payment_method_payment_order: 'Odeme  emri ',
    payment_method_payment_order_description : 'Odeme emrilerini iceren satin alma ile ilgili proforma e-posta ile gonderilecek. Siparis,odeme alindiktan sonra verilecektir.',
    payment_method_credit_erv: 'e - rovinieta kredi ',
    payment_method_credit_tpf: 'Fetesti kopru gecis ucretinin kredisi ',
    payment_method_terms: 'Yukaridaki verilerin dogru oldugunu ve okudugumu hukum ve kosullari kabul ettip onayliyorum',
    thank_you_placed_order_title: 'Siparis verildi ',
    thank_you_successful_order: 'Siparisin  verilmesi basarili!',
    thank_you_see_info_order: 'Durumunu Siparislerim de gorun ',
    thank_you_my_orders: 'Siparislerim ',

    //Account
    continue_with: 'Continue with',
    account_activate_header: 'Hesabi acin ',
    account_activate_message: '',

    account_container_my_account: 'Hesabim ',
    account_container_vehicles: 'Araclar ',
    account_container_orders: 'Siparisler ',
    account_container_profiles: 'Faturalandirma profileri',
    account_container_info: 'Hesap verisi ',

    account_data_title: 'Hesap detaylari ',
    add_car_title: 'Arac eklemesi ',

    add_profile_title: 'Profil eklemesi ',
    add_profile_pj_extracted: 'Otomatik olarak cikarilan tuzel kisiligin verileri ',

    edit_car_no_vehicles: 'Arac bulunamadi!',
    edit_car_delete_vehicle_title: 'Araci silin ',
    edit_car_delete_vehicle: 'Bu araci silmesinden emin misiniz?  ',

    my_orders_passings: 'Bir gecis / gecisler ',

    profiles_main: ' Ana ',
    profiles_secondary: ' Ikincil ',
    profiles_unverified_data: 'Incelenmemis  bilgiler',
    profiles_no_profile: 'Hic bir profil bulunmamis',
    profiles_delete_profile: ' Profili silin ',
    profiles_are_you_sure: 'Profili silinmekten emin misiniz ? ',

    //Authentication
    login_auth: 'Oturum ac ',
    login_login_into_your_account: 'Hesapiniza giris yapin  ',

    login_component_login_by: ' ... ile login ',
    login_component_no_account: 'Hesapiniz  yok mu? ',
    login_component_forgot_password: 'Parolanızı mı unuttunuz?',

    new_account_title: 'Yeni hesap ',
    new_account_details: 'Hesap detaylari ',
    new_account_ive_read: 'Okuyup katiliyorum ',
    new_account_tc: 'Hukum  ve kosullari ',
    new_account_site: 'Sitenin ',
    new_account_pc: 'Gizlilik Politikasi',
    mandatory: ' Zorunlu ',
    new_account_must_accept_tc: ' Hukum ve kosullari  kabul etmelisiniz ',
    new_account_must_accept_pc: 'Gizlilik Politikasi kabul etmelisiniz ',

    contact_title: ' Kontakt ',

    header_how_does_it_work: ' Nasil calisir? ',

    how_it_works_p1: '3 dakka icinde yolla cikabilirsiniz! ',
    how_it_works_p2: ' Yetkili Distributor CNAIR',
    how_it_works_p3: 'Online siparis icin taxa-pod-fetesti.ro ',

    toll_category_error_loading_car: 'Araci yuklemede sorunu ',
    toll_category_error_loading_country: 'Ulkeyi uklemede sorunu ',

    vignette_category_error_fromdate: 'Rovinieta \'nin baslangic tarihi secin ',

    //Buttons
    btn_save: 'Kaydet ',
    btn_save_changes: 'Degisiklikleri  kaydet ',
    btn_add_car: 'Araci ekleyin ',
    btn_delete_car: 'Araci silin ',
    btn_next_step: 'Sonraki adim ',
    btn_finish: 'Tamamla ',
    btn_grab_data_company: '<br> bilgileri alin / Ticaret Sicili ',
    btn_add_profile: 'Yeni profil ekleyin ',
    btn_i_understand: ' Anladim ',
    btn_login: ' Login',
    btn_register: 'Kendini kaydet  ',
    btn_create_account: 'Hesabi olusturun   ',
    btn_add_to_cart: 'Sepete ekleyin ',
    btn_edit_to_cart: 'Ürünü değiştir',
    btn_reset_password: 'Şifreyi yenile',
    btn_bill: 'Factureaza',
    btn_choose_payment_method: 'Choose payment method',


    //Labels
    label_email: 'Email',
    label_password: 'Parola',
    label_confirm_password: 'Parolanizi onaylayin ',
    label_license_plate: 'Kayit numarasi ',
    label_chasis_number: 'Sasi serisi ',
    label_registration_country: 'Kayit ulkesi ',
    label_motif: 'Alt kategori nedeni ',
    label_choose_category: 'Kategoriyi secin ',
    label_billing_type: 'Fatura ',
    label_last_name: 'Adi ',
    label_first_name: 'Soyadi ',
    label_country: 'Ulke ',
    label_county: 'Ilce ',
    label_city: 'Sehir ',
    label_address: 'Adress ',
    label_cui: 'CUI',
    label_reg_com: 'Ticaret sicili ',
    label_locality: 'Kent ',
    label_company_name: 'Sirket adi ',
    label_for_car: 'Arac icin ',
    label_available_from: '.....den itibaren gecerli  ',

    //terms
    terms: 'Şartlar ve koşullar',
    partners: 'ortak',

    //menu pages
    how_it_works: 'Nasıl çalışır',
    info: 'Yasama bilgileri',
    for_companies: 'Şirketler için',
    distribution_untrr: 'UNTRR dağıtım noktaları listesi',
    about_us: 'Hakkımızda',
    cookies: 'Çerezler',

    //footer
    footer_new_account_link: 'Profesyonellere katıl',

    delete_product_title: 'Изтрийте продукт',
    delete_product: 'Сигурни ли сте, че искате да изтриете продукта?',

    //New terms
    btn_edit: 'Променете',
    btn_edit_password: 'Промяна на паролата',
    btn_edit_phone: 'Промяна на телефона',
    btn_delete_account: 'Изтрийте акаунта',
    btn_import_csv: 'Импортиране на csv',
    btn_export_csv: 'Експортиране на csv',

    //account
    data_saved_succesfully: 'Успешно запазени данни',
    invalid_plate_number_message: 'Номерът няма правилен формат',
    invalid: 'Невалиден',
    countries_loading: 'Проблем при зареждането на държавите',
    tpf_categories_loading: 'Проблем при зареждането на категориите на пътната такса за преминаване на моста Фетещй',
    erv_categories_loading: 'Проблем при зареждането на категориите на ровинетката',
    csv_header: 'Регистрационен номер, Шаси, Категория ровинетка, Категория пътна такса за преминаване на моста Фетещй, Държава',
    order_header_name: 'Име',
    date: 'Дата',
    order_header_payment_type: 'Вид плащане',
    order_header_status: 'Статус',
    no_placed_order: 'Няма изпратена поръчка.',
    i_want: 'Искам',
    no_order: 'Поръчката не беше намерена.',

    product_status: 'Статус',
    product_payment_method: 'Метод за плащане',
    product_bill_data: 'Данни за фактуриране',
    product_valability: 'Валидност',

    download_bill: 'Изтегляне на фактурата',
    vignette_series: 'Серия на ровинетката',
    toll_series: 'Серия изминато разстояние',

    //authentication
    login_account: 'Влизане в акаунта',
    already_have_account: 'Имате ли акаунт?',
    password: 'Парола',
    password_confirm: 'Повторете паролата',
    return_to_login_1: 'Върнете се към страницата за',
    return_to_login_2: 'Влизане',

    // order
    choose_profile: 'Изберете профил',
    order_step4: 'Стъпка 4: Фактуриране',
    login_to_your_account: 'Влезте в акаунта си',
    login_to_your_account_2: 'и изберете вече запазените данни за фактуриране.',
    order_without_account: 'Можете да изпратете поръчка без акаунт, след попълване на данните по-долу',
    fill_all_fields: 'Попълнете всички задължителни полета',
    order_address_info: 'На този адрес ще получите фактурата и ровинетката',
    invalid_profile_msg: 'Този профил не е валиден',
    delete_profile_msg: 'Изтрийте профила',
    delete_profile_confirm: 'Сигурни ли сте, че искате да изтривате профила?',
    invalid_email: 'Невалиден еmail адрес',
    invalid_tel: 'Невалиден телефон',
    mandatory_city: 'Градът е задължителен',
    mandatory_first_name: 'Презимето е задължително',
    mandatory_last_name: 'Името е задължително',
    mandatory_country: 'Окръгът е задължителен',
    mandatory_fiscal_code: 'Кодът ЕИК е задължителен',
    mandatory_j_code: 'Търговският регистър е задължителен',
    mandatory_company: 'Компанията е задължителна',
    mandatory_address: 'Адресът е задължителен',
    my_shopping_cart: 'Количката ми',
    order_step3: 'Стъпка 3: Обобщение',
    buy_vignette_or_bridge_fee: 'Можете да си купите ровинетка или пътна такса за преминаване на моста Фетещй',
    order_step5: 'Стъпка 5: Плащане',
    warning: 'ВНИМАНИЕ!',
    warning_txt_1: 'За плащане на ровинетките с платежно нареждане, поръчката ще бъде одобрена след получаването на парите в банковата сметка на UNTRR.',
    warning_txt_2: 'Закупените ровинетки с платежно нареждане се издават от понеделник до петък, от 08:00 – 16:30 часа.',
    warning_txt_3: 'Не тръгвайте преди да получите потвърждение за издаване на ровинетката.',
    warning_txt_4: 'UNTRR не отговоря за неспазването на условията по-горе!',
    choose_card: 'Изберете една от вашите запазени карти',
    new_card: 'Нова карта',
    add_card_for_next_transactions: 'Добавете картата в акаунта си за бъдещи покупки',

    free: 'Безплатно',
    btn_logout: 'Излизане',
    info: 'Инфо',

    frequent_questions_heading: 'Често зададени въпроси и отговори',
    see_all_frequent_questions: 'Вижте всички често зададени въпроси и отговори',

    step: 'Step {n}',
    choose_passings_number: 'Изберете броя на преминаванията',
    vehicles: 'Автомобили',

    juridical_person: 'Юридическо лице',
    individual_person: 'Физическо лице',
    auto_query_company_data: 'Автоматично извличаме данните за вашата компания',
    verified_company_data: 'Проверени данни за компанията!',
    unverified_company_data: 'Непроверени данни за компанията',
    check_vignette_valability: 'Проверете валидността на ровинетката',
    resources: 'Ресурси',
    i_want_vignette: 'Искам ровинетка',
    i_want_toll: 'Искам пътна такса за преминаване на моста Фетещй',
    vehicle_type: 'Вид превозно средство',
    period: 'Период',
    summary: 'Обобщение',
    billing: 'Фактуриране',
    payment: 'Плащане',
    you_have_multiple_usernames: 'Имате<b>{count}</b> свързани сметки с този имейл.',
    choose_login_account: 'Изберете акаунта, с който искате да влезете',

    //benefits page
    bp_company_advantages: 'Ползи за компании',
    bp_one_account_multiple_advantages: 'Един акаунт, повече ползи',
    bp_contact_us_for_personalized_solution: 'Свържете се с нас за персонализирано решение',
    bp_online_emission: 'Онлайн издаване 24/7',
    bp_online_assistance: 'Получавате онлайн поддръжка и можете за закупите ровинетка или пътна такса за преминаване на моста Фетещй 24/7',
    bp_import_your_cars: 'Импортирайте целия автопарк',
    bp_import_you_cars_through_excel: 'Импортирайте при нас целия автопарк на фирмата, въз основа на excel файл.',
    bp_multiple_profiles: 'Повече профили',
    bp_multiple_profiles_for_same_email: 'Имате възможността да създавате повече профили за всички потребители на фирмата, със същия имейл адрес.',
    bp_vignettes_status: 'Статус ровинетки',
    bp_verify_vignette_status: 'На сайта можете през цялото време да проверете статуса на издадените ровинетки.',
    bp_orders_history: 'История на поръчките',
    bp_orders_history_description: 'В акаунта можете да намерите всички изпратени поръчки и фактури.',
    bp_multiple_orders: 'Множество поръчки',
    bp_multiple_orders_description: 'Можете да добавите повече ровинетки в количката и да изпратите множество поръчки.',
    bp_email_sms_confirmation: 'Потвърждение по имейл и SMS',
    bp_email_sms_confirmation_description: 'Получавате потвърждение за издаването на ровинетката по имейл и SMS.',
    bp_expiry_alerts: 'Предупреждения за изтичане',
    bp_expiry_alerts_description: 'За ровинетки за ровинетките от и над 30 дни ще ви уведомим по имейл, преди датата на изтичането.',
    bp_need_help: 'Имате ли нужда от помощ?',
    bp_call_operators: 'Свържете се с един от нашите оператори за съдействие при издаването на ровинетката. Услугата е на разположение от понеделник до петък (с изключение на официалните празници), от 8 до 17 часа. ',
    bp_offices: 'Списък с представителите',
    bp_have_cars: 'Притежавате ли флот от превозни средства?',
    bp_contact_us_for_personalized_solution_for_your_bussiness: 'Свържете се с нас за персонализирано решение за вашия бизнес.',
    bp_contact_us_now: 'Свържете се сега с нас',


    //contact
    contact_viggnete_emission: 'Издаване на ровинетки',
    contact_agencies: 'Агенции',
    contact_see_all_agencies: 'Вижте всички регионални агенции',
    contact_see_all_agencies_continuation: 'от къде можете да купите ровинетки.',

    //distribution
    distribution_header: 'СПИСЪК НА РАБОТНИТЕ ТОЧКИ НА UNTRR, РАЗРЕШЕНИ ДА СЪБИРАТ ТАРИФАТА ЗА ИЗПОЛЗВАЕ НА НАЦИОНАЛНАТА РУМЪНСКА ПЪТНА МРЕЖА (ROVINIETA)',
    distribution_nr_crt: '№',
    distribution_work_point: 'Обект',
    distribution_terminals_and_portals: 'УЕБ ТЕРМИНАЛИ И ПОРТАЛИ',
    distribution_name: 'Наименование',
    distribution_terminals: 'Терминали ZEBRAPAY',
    distribution_location_terminal_details: 'Подробности за местоположението на терминалите на ZEBRAPAY',
    distribution_untrr_portal: 'ПОРТАЛ НА UNTRR',


    //footer
    footer_copyright: 'Всички права запазени 2010 - 2020 г. @ Национален съюз на автомобилните превозвачи в Румъния.',


    //homepage
    homepage_authorized_distributor: 'Разрешен дистрибутор на C.N.A.I.R',
    homepage_buy_tpf_erv: 'Купете ровинетка или пътна такса за преминаване на моста Фетещй',
    homepage_ready_for_road: 'Незабавно готови за път',
    homepage_order: 'Поръчайте',
    homepage_payment: 'Платете',
    homepage_drive: 'Пътувайте',
    homepage_your_advantages: 'Вашите ползи',
    homepage_vignette_availability: 'Проверявате валидността на ровинетката',
    homepage_vignette_availability_description_1: 'Не знаете ли дали ровинетката е валидна? Избягвайте евентуална глоба.',
    homepage_vignette_availability_description_2: 'Проверете валидността тук',
    homepage_save_data: 'Запазете данните',
    homepage_save_data_description: 'Създавате акаунт, запазвате данните за автомобила и купувате ровинетката и пътна такса за преминаване на моста Фетещй на едно място.',
    homepage_sms_email_delivery: 'Доставка по мейл и SMS',
    homepage_sms_email_delivery_description: 'Доставка по мейл и SMS',
    homepage_card_or_op: 'Плащате с карта или банков превод',
    homepage_card_or_op_description: 'Бърза и сигурна покупка с банковата карта или платежно нареждане.',
    homepage_notify_expiry: 'Уведомление за изтичане',
    homepage_notify_expiry_description: 'За ровинетки за по-дълъг период от 30 дни ви предупреждаваме, преди изтичане.',
    homepage_professional_services: 'Професионални услуги',
    homepage_professional_services_description: 'От професионалисти в областта на транспорта за всички потребители на румънската пътна мрежа.',
    homepage_online_assistance: 'Освен това получавате онлайн поддръжка и персонализирано решение за нуждите на бизнеса ви.',
    homepage_discover_all_benefits: 'Открийте всички ползи',
    homepage_distribution_points: 'точки за дистрибуция',
    homepage_authorized_distributor_2: 'UNTRR е разрешен дистрибутор от C.N.A.I.R. за издаване на електронни ровинетки, с онлайн присъствие и териториални точки.',
    homepage_distribution_points_description: 'Вижте списъка с точките за дистрибуция',
    homepage_frequent_questions: 'Често зададени въпроси и отговори',
    homepage_frequent_questions_description: 'Вижте всички често зададени въпроси и отговори',

    //info
    info_download_file: 'Свали файл',

    //reset
    reset_cart: 'Количката беше нулирана.',

    sms_notice: '<strong>SMS ile ücret karşılığı bildirim Hizmeti</strong><br/><br/> Kısa mesaj (SMS) ile bildirim hizmeti, www.taxa-pod-fetesti.ro müşterilerinin köprü geçiş ücreti düzenlendiği teyidi için, sırasıyla müşterilerin köprü geçiş ücreti geçerlilik süresințn sona erdiği bildirimini sağlar. Hizmet opsiyonel, müşterinin tercihine bağlı ve yalnızca (PayU) ödeme işlemcisi aracılığıyla çevrimiçi olarak ödenen siparişler için geçerlidir.<br/><br/> SMS’deki köprü geçiş ücreti düzenlenme süresinin sona ermesi, www.taxa-pod-fetesti.ro platformuna girilen araç plakası, şasi serisi, mobil telefonu ile ilgili verilerin ve bilgilerin doğrululuğu sadece kullanıcının sorumluluğudur.<br/><br/> SMS ile bildirim NETOPIA Payments vasıtasıyla gerçekleşmektedir.<br/><br/> SMS bildirim sistemi, ancak bu hizmeti tercih eden müşterilere SMS ile bildirimler gönderir.<br/><br/> Onay sonu SMS&#39;inin alınması, telekomünikasyon ağlarının işleyişinden ve kapsama alanından, kullanılan cihazların çalışmasından vb. etkilenebilir.<br/><br/>    Şikayetler için, www.taxa-pod-fetesti.ro sitesinin iletişim sayfasını kullanmanızı rica ediyoruz.<br/><br/>'

};
